<script lang="ts">
    interface Props {
        discount?: string;
    }

    let { discount }: Props = $props();
</script>

{#if discount}
    <oc-tag-v1 variant="sale" size={'50'}>{discount}</oc-tag-v1>
{/if}
